<script setup lang="ts">
// Histórico de transações do Minha Conta V2 (ENG-362).
// Figma: mobile 19771:42224 / desktop 19771:52463.
// Dados reais: mesma API da página antiga pages/user/wallet/transactions.vue
// (useWalletStore.getTransactions). "Todos" usa o type 'full' do BFF
// (extrato completo — a página antiga não tinha tab "Todos").
// `filter` pré-seleciona a tab — vem do ?filter= da rota (sem rota dedicada
// por tab, ver openByPath/HistoryTransactionsList).
interface Props {
  filter?: string;
}

const props = defineProps<Props>();

// bonus/coupon/clubevip: mesmo POST /bff/transactions (getTransactions já
// manda o type certo). cashback: getTransactions já desvia sozinho pro GET
// /transactions/cashback quando o type bate com /cashback/gi — mesmo
// endpoint que a aba "Cashback" da página antiga usa.
const FILTERS = [
  { key: 'full', label: 'Todos' },
  { key: 'deposit', label: 'Depósito' },
  { key: 'withdraw', label: 'Saque' },
  { key: 'bonus', label: 'Bônus' },
  { key: 'coupon', label: 'Cupons' },
  { key: 'cashback', label: 'Cashback' },
  { key: 'clubevip', label: 'Clube VIP' },
];
</script>

<template>
  <UserV2HistoryTransactionsList
    :filters="FILTERS"
    :initial-filter="props.filter"
  />
</template>
